import axios from 'axios'
import { WebVTTParser } from 'webvtt-parser'

export default {

  async loadTrack(url) {
    if (this.isSrt(url)) {
      const
        response  = await axios.get(url),
        objectURL = this.convertToVTT(response.data)
      return objectURL
    } else {
      return url
    }
  },

  isSrt: url => url.split('.').pop().toLowerCase() === 'srt',

  convertToVTT: content => (
    window.URL.createObjectURL(
      new Blob([
        "WEBVTT - Generated using SRT2VTT\r\n\r\n" +
        content.replace(/(\d+:\d+:\d+)+,(\d+)/g, '$1.$2')
      ], { type: 'text/vtt' })
    )
  ),

  parse_vtt: vtt => {
    const parser = new WebVTTParser()
    const parsed = parser.parse( vtt )
    const cues = parsed.cues.map( c => c.text )
    return cues
  }

}
